export const trimTabs = (v: string) => v.replace(/\t/g, '');
